import * as antIcons from '@ant-design/icons-vue';

export const loadAntIcons = (app) => {
    Object.keys(antIcons).forEach(key => {
        app.component(key, antIcons[key]);
    });
};
